import { render, staticRenderFns } from "./freePhotoMine.vue?vue&type=template&id=5879ee16&scoped=true"
import script from "./freePhotoMine.vue?vue&type=script&lang=js"
export * from "./freePhotoMine.vue?vue&type=script&lang=js"
import style0 from "./freePhotoMine.vue?vue&type=style&index=0&id=5879ee16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879ee16",
  null
  
)

export default component.exports